import React, { useId } from "react";

/** Decorative vector artwork; not a photograph of an item for sale. */
export default function BrandGraphic({
  variant = "board",
}: {
  variant?: "board" | "acceptor" | "power";
}) {
  const gradientId = useId();
  return (
    <svg
      viewBox="0 0 480 350"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className="brand-graphic"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="70"
          y1="30"
          x2="420"
          y2="340"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#414149" />
          <stop offset="1" stopColor="#17171c" />
        </linearGradient>
      </defs>
      <ellipse cx="250" cy="313" rx="175" ry="19" fill="#000" opacity=".2" />
      <g stroke="#62626b" strokeWidth="1" opacity=".45">
        <path d="M20 90h70l35 35h70M460 70h-60l-50 50M20 260h65l30-30M460 265h-80l-30-30" />
        <circle cx="20" cy="90" r="4" />
        <circle cx="460" cy="70" r="4" />
        <circle cx="20" cy="260" r="4" />
      </g>
      {variant === "board" ? (
        <g transform="translate(82 42) rotate(-7 160 125)">
          <rect
            x="0"
            y="0"
            width="320"
            height="244"
            rx="18"
            fill={`url(#${gradientId})`}
            stroke="#777780"
            strokeWidth="2"
          />
          <g stroke="#a8232e" strokeWidth="4">
            <path d="M20 45h70l30 30v45M20 80h45l40 40M300 60h-65l-30 30M300 205h-60l-40-40M50 220v-40l50-50M265 20v35M20 140h50M170 210v25" />
          </g>
          <rect
            x="111"
            y="72"
            width="104"
            height="104"
            rx="8"
            fill="#0c0c10"
            stroke="#e14852"
            strokeWidth="3"
          />
          <path d="M132 123h63M163 92v63" stroke="#f7c744" strokeWidth="4" />
          <g fill="#c8b271">
            {[0, 1, 2, 3, 4, 5, 6, 7].map((n) => (
              <React.Fragment key={n}>
                <rect x={121 + n * 12} y="59" width="5" height="12" />
                <rect x={121 + n * 12} y="177" width="5" height="12" />
              </React.Fragment>
            ))}
          </g>
          <g fill="#f1c741">
            <circle cx="32" cy="26" r="5" />
            <circle cx="287" cy="218" r="5" />
            <circle cx="272" cy="90" r="7" />
          </g>
          <g fill="#7f808b">
            <rect x="33" y="185" width="42" height="18" rx="3" />
            <rect x="240" y="122" width="50" height="14" rx="3" />
            <rect x="240" y="146" width="50" height="14" rx="3" />
          </g>
        </g>
      ) : variant === "acceptor" ? (
        <g transform="translate(135 30) rotate(-7 105 140)">
          <path
            d="M20 10h165l35 38v222H20z"
            fill={`url(#${gradientId})`}
            stroke="#777780"
            strokeWidth="2"
          />
          <path d="M185 10v260M185 48h35" stroke="#55555d" />
          <rect
            x="38"
            y="45"
            width="128"
            height="88"
            rx="8"
            fill="#101014"
            stroke="#b52b35"
            strokeWidth="3"
          />
          <rect
            x="51"
            y="74"
            width="102"
            height="16"
            rx="3"
            fill="#050506"
            stroke="#777780"
          />
          <path d="M64 112h77" stroke="#e8c54b" strokeWidth="4" />
          <rect x="48" y="155" width="108" height="78" rx="5" fill="#33333b" />
          <path
            d="M63 172h78M63 186h78M63 200h78M63 214h78"
            stroke="#15151a"
            strokeWidth="5"
          />
          <circle cx="148" cy="29" r="4" fill="#f6ca45" />
        </g>
      ) : (
        <g transform="translate(90 80) rotate(-7 150 100)">
          <rect
            width="290"
            height="174"
            rx="13"
            fill={`url(#${gradientId})`}
            stroke="#777780"
            strokeWidth="2"
          />
          <circle
            cx="108"
            cy="86"
            r="59"
            fill="#16161c"
            stroke="#64646e"
            strokeWidth="3"
          />
          <circle cx="108" cy="86" r="16" fill="#b8202e" />
          {[0, 60, 120, 180, 240, 300].map((n) => (
            <path
              key={n}
              d="M110 65c15-30 42-17 40 6l-28 8z"
              fill="#474751"
              transform={`rotate(${n} 108 86)`}
            />
          ))}
          <path
            d="M203 35v100M217 35v100M231 35v100M245 35v100"
            stroke="#111116"
            strokeWidth="7"
          />
          <path
            d="M290 58c60 0 20 95 74 95M290 78c36 0 12 95 65 95"
            stroke="#bd2431"
            strokeWidth="6"
          />
          <rect x="26" y="151" width="42" height="10" rx="3" fill="#e5ba42" />
        </g>
      )}
    </svg>
  );
}
